// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace TestConfigurationPrintoutApi {
	export async function getTestConfigurationPrintout(args: {
		configuratorType: PartConfiguratorType;
		propertyValues: ConfigurationPropertyValues;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/testing/printout/getTestConfigurationPrintout",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
				propertyValues: args.propertyValues,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
